import { defaultClient } from '@mint-sdk/api-core';
import z from 'zod';

import { BulkTaskAcceptedSchema, BulkTaskStatusSchema } from './schemas.js';

export type {
  BulkActionName,
  BulkTaskAccepted,
  BulkTaskFailure,
  BulkTaskStatus,
  BulkTaskStatusValue,
} from './schemas.js';

const bulkUserIdsBody = z.object({
  userIds: z.array(z.number()),
});

const bulkChangeRoleBody = z.object({
  userIds: z.array(z.number()),
  roleId: z.number(),
});

export const bulkActivateUsers = defaultClient.mutation({
  url: 'authentication/v2/users/bulk/activate/' as const,
  method: 'POST',
  requestSchema: bulkUserIdsBody,
  responseSchema: BulkTaskAcceptedSchema,
});

export const bulkDeactivateUsers = defaultClient.mutation({
  url: 'authentication/v2/users/bulk/deactivate/' as const,
  method: 'POST',
  requestSchema: bulkUserIdsBody,
  responseSchema: BulkTaskAcceptedSchema,
});

export const bulkSendInvitation = defaultClient.mutation({
  url: 'authentication/v2/users/bulk/send-invitation/' as const,
  method: 'POST',
  requestSchema: bulkUserIdsBody,
  responseSchema: BulkTaskAcceptedSchema,
});

export const bulkChangeRole = defaultClient.mutation({
  url: 'authentication/v2/users/bulk/change-role/' as const,
  method: 'POST',
  requestSchema: bulkChangeRoleBody,
  responseSchema: BulkTaskAcceptedSchema,
});

export const bulkRemoveUsers = defaultClient.mutation({
  url: 'authentication/v2/users/bulk/remove/' as const,
  method: 'POST',
  requestSchema: bulkUserIdsBody,
  responseSchema: BulkTaskAcceptedSchema,
});

export const getBulkTaskStatus = defaultClient.query({
  url: 'authentication/v2/users/bulk/status/$taskId/' as const,
  method: 'GET',
  urlParamsSchema: z.object({ taskId: z.string() }),
  responseSchema: BulkTaskStatusSchema,
});
